export default __webpack_public_path__ + "static/media/aerial-command-truck.d12d9010.jpg";